// Bootstrap Dropdown Fix
jQuery('.va-dropdown').on({
	'show.bs.dropdown': function(){
		jQuery(this).find('.va-dropdown-panel').attr('hidden', false);
	},
	'hide.bs.dropdown': function(){
		jQuery(this).find('.va-dropdown-panel').attr('hidden', true);
	}
});
